import type { TranslationKey } from '@change-corgi/core/i18n';
import { YOUTUBE_BASE_PATH, YOUTUBE_REGEX } from '@change-corgi/core/richMediaTags';

import { NON_SAFE_URL_ERROR_KEY } from '../constants';

export const mediaUrlResolver =
	({ setErrorKey }: { setErrorKey: (errorKey: TranslationKey | null) => void }) =>
	(data: { url: string }, resolve: (urlResolver: { html: string }) => void): void => {
		const youtubeMatch = data.url.match(YOUTUBE_REGEX);
		if (youtubeMatch) {
			setErrorKey(null);
			const { 1: videoId } = youtubeMatch;
			const youtubeUrl = `${YOUTUBE_BASE_PATH}/${videoId}`;
			const embedHtml = `<iframe class="video-frame" src="${youtubeUrl}"></iframe>`;
			resolve({ html: embedHtml });
		} else {
			setErrorKey(NON_SAFE_URL_ERROR_KEY);
		}
	};
